export const authAppHref = 'https://app.letmoneyserve.com';

export const shouldUseExternalAuthLinks = import.meta.env.PROD && !__IS_PREVIEW__;

export const loginHref = shouldUseExternalAuthLinks ? authAppHref : '/login';

export const signupHref = shouldUseExternalAuthLinks ? authAppHref : '/signup';
